import React from 'react';
import { animated, useSpring } from '@react-spring/web';

interface PendingModalProps {
  isOpen: boolean;
  title: string;
  message: string;
}

const PendingModal: React.FC<PendingModalProps> = ({
  isOpen,
  title,
  message,
}) => {
  const animationStyle = useSpring({
    opacity: isOpen ? 1 : 0,
    config: { duration: 250 },
  });

  if (!isOpen) return null;

  return (
    <div className="fixed left-0 top-0 z-[999999] flex h-full min-h-screen w-full items-center justify-center bg-black/80 px-4 py-5">
      <animated.div
        style={animationStyle}
        className="w-full max-w-md rounded-lg bg-white px-8 py-10 text-center shadow-lg dark:bg-boxdark"
      >

        {/* Spinner simple */}
        <div className="flex justify-center mb-6">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        </div>

        {/* Título */}
        <h3 className="pb-2 text-xl font-bold text-primary dark:text-white sm:text-2xl">
          {title}
        </h3>

        {/* Mensaje */}
        <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">
          {message}
        </p>

      </animated.div>
    </div>
  );
};

export default React.memo(PendingModal);
